const API_ROOT = '/';
//const API_ROOT = 'http://tinaba-dev2-apigw-service.webscience.it';

const callApi = (endpoint, method, headers, data) => {
  const fullUrl = (endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint;

  const myHeaders = new Headers(headers);
  // const body = Object.keys(data).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}` //FOR FORM-URLENCODED
  // ).join('&');
  const body = JSON.stringify(data);  // FOR application/json

  return fetch(fullUrl, {
    credentials: 'same-origin',
    headers: myHeaders,
    method: 'POST',
    body
  })
    .then(response => {
      if (!response.ok) {
        return Promise.reject();
      }

      response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return Object.assign({},
          json
        );
      })
    }, err => {
      return Promise.reject();
    }
    );
};

// Action key that carries API call info interpreted by this Redux middleware.
export const CALL_API = 'CALL_API';

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
export default store => next => (action) => {
  const callAPI = action[CALL_API];
  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  let { endpoint } = callAPI;
  const { types } = callAPI;
  const { method } = callAPI;
  const { headers } = callAPI;
  const { data } = callAPI;

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState());
  }

  if (typeof endpoint !== 'string') {
    throw new Error('Specify a string endpoint URL.');
  }

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.');
  }
  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.');
  }
  if (typeof method !== 'string') {
    throw new Error('Specify a string Method.');
  }

  const actionWith = (actiondata) => {
    const finalAction = Object.assign({}, action, actiondata);
    delete finalAction[CALL_API];
    return finalAction;
  };

  const [requestType, successType, failureType] = types;
  next(actionWith({ type: requestType }));

  return callApi(endpoint, method, headers, data).then(
    response => next(actionWith({
      response,
      type: successType
    })),
    error => next(actionWith({
      type: failureType,
      error: error || 'Something bad happened'
    }))
  );
};



/** WEBPACK FOOTER **
 ** ./src/middleware/api.js
 **/